<template>
  <div class="newsCenter">
    <div class="colorCon"></div>
    <div class="switchCon">
      <div @click="getNewsList('reset')" :class="[flag ? 'activitySwitch leftSwitch' : 'leftSwitch']">星元资讯</div>
      <div @click="getDynamicsList('reset')" :class="[flag ? 'rightSwitch' : 'rightSwitch activitySwitch']">星元动态</div>
    </div>
    <div class="consult" v-if="flag">
      <div class="listCon">
        <div class="list" v-for="(item,index) in newsList" :key="index" @click="goPage('consult',item.id)">
          <img :src="item.img" alt="" class="list_left">
          <div class="list_right">
            <div class="firstLine">{{ item.title }}</div>
            <div class="secondLine">{{ item.publish_date }}</div>
          </div>
        </div>
      </div>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-size="4"
        layout="total, prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
    <div class="dynamics" v-else>
      <el-row :gutter="52">
        <el-col :span="6" v-for="(item,index) in dynamicsList" :key="index">
          <div class="list" @click="goPage('dynamics',item.id)">
            <img v-if="item.video_url" :src="item.video_cover_url" alt="" class="header">
            <img v-else :src="item.image_url[0] ? item.image_url[0] : ''" alt="" class="header">
            <div class="textCon">
              <p class="title">{{item.title}}</p>
              <div class="infoCon">
                <div class="left">
                  <img :src="item.company_logo" class="logo" alt="" @error="setDefaultImg">
                  <div class="companyName">{{item.company_name}}</div>
                </div>
                <div class="right">
                  <img src="../assets/view.png" class="view" alt="">
                  <span>{{item.view_count}}</span>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-pagination
        @current-change="handleDynamicsChange"
        :current-page.sync="page2"
        :page-size="8"
        layout="total, prev, pager, next"
        :total="dynamicTotal">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  data() {
    return{
      newsList: [],
      page: 1,
      total: 0,
      flag: true,
      dynamicsList: [],
      dynamicTotal: 0,
      page2: 1,
    }
  },
  mounted() {
    this.getNewsList();
  },
  activated() {
    document.title = "星元计划-新闻中心";
  },
  methods: {
    setDefaultImg(event) {
      event.target.src = require("../assets/head2.png");
    },
    goPage(page, id) {
      this.$router.push({path: '/' + page, query: {id: id}})
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getNewsList();
    },
    handleDynamicsChange(val) {
      this.page2 = val;
      this.getDynamicsList();
    },
    getDynamicsList(reset) {
      this.flag = false;
      if(reset) {
        this.page = 1;
      }
      $.ajax({
        type: "get",
        url: "/officialapi/custom/list",
        async: true,
        data: {
          "page": this.page2,
          "page_size": 8
        },
        success: (data) => {
          if (data["code"] == 0) {
            this.dynamicsList = data.data.list;
            this.dynamicTotal = data.data.total_count;
          } else {
            this.$message.error(data.msg);
          }
        }
      })
    },
    getNewsList(reset) {
      this.flag = true;
      if(reset) {
        this.page = 1;
      }
      $.ajax({
        type: "get",
        url: "/officialapi/articles/index",
        async: true,
        data: {
          "page": this.page,
          "page_size": 4
        },
        success: (data) => {
          if (data["code"] == 0) {
            this.newsList = data.data.list;
            this.total = data.data.total_count;
          } else {
            this.$message.error(data.msg);
          }
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.newsCenter{
  position: relative;
  padding: 58px 0px 53px 0px;
  background: #F9FAFB;
  .colorCon{
    position: absolute;
    height: 180px;
    width: 100%;
    background: linear-gradient(180deg, #DAE6FF 0%, rgba(228, 237, 255, 0) 99%);
    top: 0;
    left: 0;
    z-index: 0;
  }
  .switchCon{
    position: relative;
    z-index: 999;
    margin: 0 auto;
    margin-bottom: 48px;
    width: 360px;
    height: 50px;
    line-height: 50px;
    border-radius: 99px;
    background: #FFFFFF;
    box-sizing: border-box;
    border: 1px solid #4A90E2;
    font-family: Source Han Sans;
    font-size: 16px;
    font-weight: normal;
    display: flex;
    align-items: center;
    letter-spacing: normal;
    color: #666666;
    text-align: center;
    cursor: pointer;
    .leftSwitch{
      width: 50%;
      height: 100%;
    }
    .rightSwitch{
      width: 50%;
      height: 100%;
    }
    .activitySwitch{
      border-radius: 152px;
      background: #4A90E2;
      color: #fff;
    }
  }
  .consult{
    width: 1200px;
    margin: 0 auto;
    .listCon{
      .list{
        padding: 22px 0 24px 0;
        border-bottom: 0.5px solid #D8D8D8;
        display: flex;
        align-items: center;
        cursor: pointer;
        .list_left{
          width: 200px;
          height: 100px;
          border-radius: 10px;
          margin-right: 23px;
        }
        .list_right{
          .firstLine{
            font-family: Source Han Sans;
            font-size: 20px;
            font-weight: bold;
            line-height: 22px;
            letter-spacing: normal;
            color: #222222;
            margin-bottom: 35px;
          }
          .secondLine{
            font-family: Source Han Sans;
            font-size: 14px;
            font-weight: normal;
            line-height: 22px;
            letter-spacing: normal;
            color: #666666;
          }
        }
      }
    }
    .el-pagination{
      margin-top: 35px;
      text-align: right;
    }
  }
  .dynamics{
    width: 1200px;
    margin: 0 auto;
    .list{
      margin-top: 43px;
      background: #fff;
      border-radius: 10px;
      cursor: pointer;
      overflow: hidden;
      .header{
        width: 100%;
        height: 260px;
      }
      .textCon{
        padding: 15px;
        .title{
          font-family: Source Han Sans;
          font-size: 16px;
          line-height: 22px;
          color: #222222;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          height: 44px;
        }
        .infoCon{
          display: flex;
          justify-content: space-between;
          align-items: center;
          .left{
            display: flex;
            align-items: center;
            .logo{
              width: 34px;
              height: 34px;
              border-radius: 50%;
              margin-right: 5px;
            }
            .companyName{
              font-family: Source Han Sans;
              font-size: 16px;
              font-weight: normal;
              line-height: 22px;
              letter-spacing: normal;
              color: #9E9E9E;
              width: 110px;
              white-space:nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          .right{
            display: flex;
            align-items: center;
            .view{
              width: 26px;
              height: 26px;
            }
            span{
              font-family: Source Han Sans;
              font-size: 14px;
              font-weight: 500;
              line-height: 12px;
              display: flex;
              align-items: center;
              letter-spacing: normal;
              color: #989898;
            }
          }
        }
      }
    }
    .el-pagination{
      margin-top: 35px;
      text-align: right;
    }
  }
}
</style>